var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "recent_tx"
  }, [_c('RecentTxHeader', {
    attrs: {
      "heading": "Recent Transactions",
      "loading": _vm.loading
    },
    on: {
      "update": _vm.updateTx
    }
  }), _c('div', {
    staticClass: "list"
  }, [_c('TxTableHead'), _vm.transactions ? [_vm.transactions.length > 0 ? _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.transactions, function (tx) {
    return _c('TxRow', {
      key: tx.id,
      staticClass: "recent_tx_rows",
      attrs: {
        "transaction": tx
      }
    });
  }), 1) : _vm._e(), _vm.transactions.length === 0 ? _c('div', [_c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1) : _vm._e()] : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }